// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"RiskAnalysisPage_sectionHeader__bIir-"};